import fetchApi from "../fetchApi";
import { DEFAULT_LIMIT } from "../../contstants";
export const GetPrograms = async (
  limit = DEFAULT_LIMIT,
  offset = 0,
  name = "",
  company_id = "",
  office_id = "",
  status = "",
  dateFrom = "",
  dateTo = "",
  id = ""
) => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(
    `card-issuing/cardholder/programs?limit=${limit}&offset=${offset}&name=${name}&company_ids=${company_id}&office_id=${office_id}&status=${status}&created_on_gte=${dateFrom}&created_on_lte=${dateTo}&ids=${id}`,
    options
  );
};
